<template>
  <div style="overflow-x: hidden;background-color: white;position: absolute;left: 0;right: 0;top: 0" class="bg">
    <Navigator/>
    <SliderBanner :slider="slider"/>
    <FuncShow :funInfo="funInfo" style="background: #F4F7FF"/>
    <FuncBanner :funcData="funcData" style="background: #F4F7FF"/>
    <Footer/>
    <ContactFloat/>
  </div>
</template>

<script>
import Navigator from '../widgets/navigator'
import Footer from '../widgets/footer'
import SliderBanner from '../widgets/SliderBanner'
import FuncShow from '../widgets/func-show'
import FuncBanner from '../widgets/fun-banner'
import ContactFloat from '../widgets/contact-float.vue'

export default {
  components: {
    Navigator,
    FuncShow,
    FuncBanner,
    ContactFloat,
    SliderBanner,
    Footer
  },
  data() {
    return {
      funcData: [
        {
          title: '自定义编辑',
          subTitle: '可视化自定义编辑平台，页面装修随心DIY！智莺系统采用可视化模板设计方式，让首页、导航、楼层、广告位、专题、商家店铺以及移动端可以根据自己网站的需求随意变动装修；系统自带多套首页模板，为运营者个性化设计自己的商城提供了更多的选择。',
          carouseImg: require('@/assets/images/index/b2c-mall/banner1.png')
        }
      ],
      slider: {
        image: require('@/assets/images/index/b2c-mall/phone.png'),
        title: 'S2B2C商城',
        desc: "S2B2C商城系统是打造支持招商入驻经营模式的电商平台，模块化设计整合运营商，供货商，入驻商，分销商于一体，各个模块可自由拆分组合，可以让商家在这个电商多样化的时代下随时调整运营方案。"
      },
      funInfo: {
        title: 'S2B2C商城',
        list: [
          {
            title: '分销小店',
            img: require('@/assets/images/index/b2c-mall/img1.png'),
            text: '智莺分销市场甄选好物,让千万人共享，为中小企业和流量媒体建立分销网络,快速获取订单，海量资源更优质,分销渠道更多样，我们为百万用户提供强大的供销系统，触达上亿目标消费者，我们为供货商建立全面的市场渠道。'
          },
          {
            title: '入驻商家',
            img: require('@/assets/images/index/b2c-mall/img2.png'),
            text: '每个入驻商家都有自己独立的管理后台，可进行商品管理、店铺管理、资产管理、分店管理、售后管理、营销管理 、客户管理等，支持电脑web和手机端管理，方便门店不同场景的使用。'
          },
          {
            title: '打折促销',
            img: require('@/assets/images/index/b2c-mall/img3.png'),
            text: '简单实用的营销管理，可灵活自定义的营销管理，无须培训、操作简单,有效积累了丰富的培训经验,用户行为规范,数据安全可靠,专为中小企业量身设计,让用户不再流失、稳定可靠。'
          },
          {
            title: '平台运营',
            img: require('@/assets/images/index/b2c-mall/img4.png'),
            text: '强大的数据分析能力，解决运营难题，多方面了解商城经营数据，消费者行为数据，用于调整策略参考，更有实时交易数据监控，帮助你快速发现数据之间的联系及背后的价值，多方面分析， 让你轻松把握商业趋势，及时应对变化。'
          },
          {
            title: '资产管理',
            img: require('@/assets/images/index/b2c-mall/img5.png'),
            text: '多用户商城的资产管理，可以查看账户余额、账户的数据统计、余额提现、收支明细等功能；移动互联网时代，PC端平台管理便捷性遭遇挑战，手机端就可以简单操作。'
          }
        ]
      }
    }
  }
}
</script>

<style scoped lang="scss">
</style>
